import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const AttendancePieChart = ({ data }) => {
    const svgRef = useRef();

    useEffect(() => {
        if (!data || data.length === 0) return;

        const width = 280;
        const height = 280;
        const radius = 120; // Slightly smaller to allow for expansion without clipping

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        // Tooltip
        const tooltip = d3.select("body").append("div")
            .attr("class", "d3-tooltip");

        const g = svg.append("g")
            .attr("transform", `translate(${width / 2},${height / 2})`);

        const pie = d3.pie()
            .value(d => d.value)
            .sort(null);

        const arc = d3.arc()
            .innerRadius(radius * 0.75) // Thinner Donut
            .outerRadius(radius);

        const arcHover = d3.arc()
            .innerRadius(radius * 0.75)
            .outerRadius(radius + 6);

        // Add Paths
        g.selectAll('path')
            .data(pie(data))
            .enter()
            .append('path')
            .attr('d', arc)
            .attr('fill', d => d.data.color)
            .attr('stroke', 'white')
            .style('stroke-width', '2px')
            .style('cursor', 'pointer')
            .on('mouseover', function (event, d) {
                d3.select(this).transition().duration(200).attr('d', arcHover).style("opacity", 0.8);

                // Center Text Update
                svg.select(".center-text-label").text(d.data.label).style("fill", d.data.color);
                svg.select(".center-text-value").text(d.data.value + "%");

                tooltip.style("visibility", "visible")
                    .html(`<strong>${d.data.label}</strong>: ${d.data.value}%`);
            })
            .on('mousemove', function (event) {
                tooltip.style("top", (event.pageY - 10) + "px")
                    .style("left", (event.pageX + 10) + "px");
            })
            .on('mouseout', function (event, d) {
                d3.select(this).transition().duration(200).attr('d', arc).style("opacity", 1);

                svg.select(".center-text-label").text("Today").style("fill", "#64748b");

                // Recalculate average attendance (Present + WFH)
                const totalAttendance = data.reduce((acc, curr) => (curr.label === 'Present' || curr.label === 'WFH') ? acc + curr.value : acc, 0);
                svg.select(".center-text-value").text(totalAttendance + "%");

                tooltip.style("visibility", "hidden");
            })
            .transition()
            .duration(1000)
            .attrTween("d", function (d) {
                const i = d3.interpolate(d.startAngle, d.endAngle);
                return function (t) {
                    d.endAngle = i(t);
                    return arc(d);
                };
            });

        // Center Text
        const totalInit = data.reduce((acc, curr) => (curr.label === 'Present' || curr.label === 'WFH') ? acc + curr.value : acc, 0);

        g.append("text")
            .attr("class", "center-text-label")
            .attr("text-anchor", "middle")
            .attr("dy", "-0.6em")
            .style("font-size", "12px")
            .style("fill", "#64748b")
            .style("font-weight", "500")
            .text("Today");

        g.append("text")
            .attr("class", "center-text-value")
            .attr("text-anchor", "middle")
            .attr("dy", "1em")
            .style("font-size", "22px")
            .style("font-weight", "bold")
            .style("fill", "#1e293b")
            .text(totalInit + "%");

        return () => {
            tooltip.remove();
        };

    }, [data]);

    return <svg ref={svgRef} width="280" height="280" viewBox="0 0 280 280" style={{ maxWidth: '100%', height: 'auto' }}></svg>;
};

export default AttendancePieChart;
